import { OAuthState } from "../shared/types";
import { encodeOAuthState } from "../shared/utils";

export function getOAuthLink({ state }: { state?: OAuthState } = {}): string {
  const host = import.meta.env.DEV
    ? `http://${window.location.hostname}:${window.location.port}`
    : window.location.hostname.includes("staging")
      ? "https://staging.s-process.app"
      : "https://s-process.app";
  let oauthLink = "https://accounts.google.com/o/oauth2/v2/auth";
  oauthLink +=
    "?scope=" +
    encodeURIComponent(
      "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
    );
  oauthLink += "&client_id=" + import.meta.env.VITE_OAUTH_CLIENT_ID;
  oauthLink +=
    "&redirect_uri=" + encodeURIComponent(`${host}/api/googleOAuthCallback`);
  oauthLink += "&response_type=code";
  oauthLink += "&access_type=offline";

  state = state ?? getState();
  if (state) {
    oauthLink += "&state=" + encodeOAuthState(state);
  }

  return oauthLink;
}

function getState(): OAuthState {
  return {
    type: "RedirectLocation",
    redirectLocation: window.location.href,
  };
}
